// extracted by mini-css-extract-plugin
export var chevron = "_kp-4";
export var chevronExpanded = "_kp-5";
export var row = "_kp-0";
export var rowBody = "_kp-6";
export var rowDescription = "_kp-7";
export var rowHeader = "_kp-1";
export var rowTitle = "_kp-2";
export var rowTitleComplete = "_kp-3";